import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useInfinityCustomer } from "../../context/InfinityCustomerContext";
import InfinityOrderList from "./InfinityOrderList";

/** Standalone orders page (also embedded on Home). Enriched details via the shared list. */
export default function InfinityOrders() {
  const { http, isAuthed, basePath } = useInfinityCustomer();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthed) { navigate(`${basePath}/login`); return; }
    http.get("/orders").then((r) => setOrders(r.data?.data || [])).catch(() => {}).finally(() => setLoading(false));
  }, []); // eslint-disable-line

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-slate-900">Print Orders</h2>
        <Button onClick={() => navigate(`${basePath}/shop`)}>Place New Order</Button>
      </div>
      <InfinityOrderList orders={orders} loading={loading} />
    </div>
  );
}
